import { Component, computed, EventEmitter, OnInit, Output, Signal, inject } from '@angular/core';
import { CardStatus, CardStatusLabel } from '../../../../../_interfaces/cards.interface';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FilterButtonComponent,
  FilterGroup,
  FilterGroupType,
  FilterOption,
} from '../../../../../shared/components/filter-button/filter-button.component';
import { HttpParams } from '@angular/common/http';
import { EmployeeRoleState } from '../../../../../_interfaces/employee.interface';
import { updateParamsObjectToPageOne } from '../../../../../shared/utils/filter-utils';

interface SearchParams {
  status: string;
}

@Component({
  selector: 'app-cards-filter',
  imports: [FilterButtonComponent],
  templateUrl: './cards-filter.component.html',
})
export class CardsFilterComponent implements OnInit {
  readonly router = inject(Router);
  readonly route = inject(ActivatedRoute);

  @Output() query: EventEmitter<HttpParams> = new EventEmitter<HttpParams>();
  @Output() filterApplied: EventEmitter<boolean> = new EventEmitter<boolean>();

  protected statusParams: Signal<SearchParams> = computed(() => {
    const queryParams = this.route.snapshot.queryParams;
    return {
      status: queryParams['status'] ?? '',
    };
  });

  protected filterGroup: Array<FilterGroup> = [];
  queryParams = new HttpParams();

  ngOnInit(): void {
    const statusQuery: string[] = this.statusParams().status.split(',');
    this.filterApplied.emit(Boolean(statusQuery[0]));

    this.filterGroup = [
      {
        filterLabel: 'Card status',
        param: 'status',
        options: [
          {
            label: CardStatusLabel.ACTIVE,
            value: CardStatus.Active,
            type: FilterGroupType.checkbox,
            checked: statusQuery.includes(CardStatus.Active.toString()),
          },
          {
            label: CardStatusLabel.BLOCKED,
            value: CardStatus.Blocked,
            type: FilterGroupType.checkbox,
            checked: statusQuery.includes(CardStatus.Blocked.toString()),
          },
          {
            label: CardStatusLabel.REMOVED,
            value: CardStatus.Removed,
            type: FilterGroupType.checkbox,
            checked: statusQuery.includes(CardStatus.Removed.toString()),
          },
        ],
      },
    ];
  }

  onFilter(options: Array<FilterOption>) {
    const checkedOptions = options.filter((opt) => opt.checked);
    const statusQuery: EmployeeRoleState[] = [];
    this.filterApplied.emit(checkedOptions.length > 0);
    if (checkedOptions.length > 0) {
      checkedOptions.forEach((opt) => {
        statusQuery.push(opt.value as EmployeeRoleState);
      });
      if (statusQuery) {
        this.queryParams = this.queryParams.set('status', statusQuery.toString());
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: updateParamsObjectToPageOne(this.queryParams),
        });
      }
    } else {
      // remove role from params entirely
      this.queryParams = this.queryParams.delete('status');
      this.router.navigate([], {
        queryParams: { 'status': null },
        queryParamsHandling: 'merge',
      });
    }
  }
}
